import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { Underwriter } from '../models/Underwriter';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-underwriter-dialog',
  templateUrl: './underwriter-dialog.component.html',
  styleUrls: ['./underwriter-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatDialogModule, 
    MatButtonModule, 
    MatIcon, 
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatExpansionModule
  ]
})
export class UnderwriterDialogComponent implements OnInit {

  form!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<UnderwriterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.initForm();

    if (this.data) {
      this.populateForm(this.data);
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['']
    });
  }

  populateForm(underwriter: Underwriter) {
    this.form.patchValue(underwriter);
  }

  submitUnderwriter() {
    let payload = {
      id: this.data != undefined ? this.data.id : null,
      name: this.form.get('name')?.value,
      description: this.form.get('description')?.value,
      is_active: true
    }
    this.dialogRef.close(payload);
  }

  canCreateUnderwriter(): boolean {
    return (
      this.form.valid
    );
  }
}